module.exports = __webpack_public_path__ + "static/media/HAUX_MAIS_VIDA_7.e8749aa6.pdf";